import { ar, enUS, fr, type Locale } from 'date-fns/locale';

import type { SupportedLanguage } from '@klareospace/pharos-lib-types';

export type { SupportedLanguage } from '@klareospace/pharos-lib-types';

const DATE_LOCALES: Record<SupportedLanguage, Locale> = {
  ar,
  en: enUS,
  fr,
};

export function getDateLocale(language: string): Locale {
  return DATE_LOCALES[language as SupportedLanguage] ?? enUS;
}
